


























import PopupForms from '@/pages/default/popup/forms/component.vue';
import isAuthorized from '@/mixins/isAuthorized';
import { Modal as modalWindow } from '@/components/modal';
const MODAL_HEADER_REGISTRATION = 'Здравствуйте, регистрация прошла успешно!';
const MODAL_HEADER_CONFIRMEMAIL = 'Здравствуйте, подтвердите почту!';
import ExtButton from '@/components/ext/Button.vue';
import Confirm from '@/components/emailconfirm';
export default {
  name: 'AuthPopups',
  components: { PopupForms, modalWindow, ExtButton, Confirm },
  mixins: [isAuthorized],
  inject: ['$config'],
  data() {
    return {
      justSignUp: false,
      modalTextHeader: MODAL_HEADER_REGISTRATION,
      disabled: false,
    };
  },
  watch: {
    '$store.state.user.nube'(value: any) {
      if (value) {
        this.justSignUp = true;
      }
    },
  },
  methods: {
    closeModalConfirmEmail() {
      this.justSignUp = false;
      if (this.$store.state.nextOpenModuleCard) {
        this.$store.nextOpenModuleCard = false;
        return;
      }
      if (this.$store.state.nextOpenModuleCard) {
        this.$store.nextOpenModuleCard = false;
        return;
      }
      if (this.modalTextHeader === MODAL_HEADER_REGISTRATION) {
        if (!this.$store.state.user.after_register) {
          if (this.$route.name === 'start-page') {
            this.$router.push({ name: 'profile-settings' });
          }
        }
      } else {
        this.modalTextHeader = MODAL_HEADER_REGISTRATION;
      }
    },
    clearDisabled() {
      this.disabled = false;
    },
    confirm() {
      if (this.confirmEmail) {
        this.resendConfirmEmail()
          .then(({ data: { success } }) => {
            if (success) {
              this.modalTextHeader = MODAL_HEADER_CONFIRMEMAIL;
              this.justSignUp = true;
              this.disabled = true;
            }
          })
          .catch((err) => {
            this.disabled = false;
          });
      }
    },
  },
  computed: {
    userEmail() {
      const { profile } = this;
      return profile && profile.email;
    },
    state() {
      return this.$store.state;
    },
    agreeWithTheCookie() {
      return !this.state.agreeWithTheCookie;
    },
    user() {
      return this.state.user;
    },
    profile() {
      return this.user.profile;
    },
    isVerifiedEmail() {
      const { profile } = this;
      return profile && profile.is_verified;
    },
    confirmEmail() {
      const { isAuthorized, isVerifiedEmail } = this;
      return isAuthorized && !isVerifiedEmail;
    },
    hasBasicAuth() {
      return !this.hasExternalAuth;
    },
    hasExternalAuth() {
      const { $config, $store } = this;
      const { auth = {} } = $config;
      return auth.dnevnikRu && $store.getters.hasApiModuleDnevnikRu;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/specialContents/authPopups/AuthPopups.vue